import styled, { css } from 'styled-components';
import colors from '../../../../../assets/colors';

export const Content = styled.div`
  padding: 30px 30px 10px;
  display: flex;

  .left {
    margin-right: 30px;
  }

  .right {
    flex: 1;
  }

  @media screen and (max-width: 619px) {
    flex-direction: column;
    
    .left { margin-bottom: 30px; }
  }
`;

export const DropContainer = styled.div`
  .container {
    p.title {
      font-size: 0.9rem;
      font-weight: 700;
      color: #999;
      letter-spacing: -0.5px;
      padding-bottom: 8px;
    }
  }

  @media screen and (min-width: 769px) {
    display: flex;

    .container {
      margin-right: 15px;
      flex: 1;

      :last-child {
        margin-left: 15px;
        margin-right: 0;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .container {
      :last-child {
        margin-top: 30px;
      }
    }
  }
`;

const dragActive = css`
  border: 2px solid ${colors.primary};
`;

const dragReject = css`
  border: 2px solid ${colors.red};
`;

export const DropContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 146px;
  height: 170px;
  padding: 0 12px;
  background-color: ${colors.white};
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  border-radius: 8px;
  border: 2px solid ${colors.white};
  cursor: pointer;
  
  ${props => (props.isDragActive && dragActive)};
  ${props => (props.isDragReject && dragReject)};

  .fa {
    font-size: 3.6rem;
    color: ${colors.primary};
  }

  h3 {
    font-size: 0.9rem;
    font-weight: 700;
    color: ${colors.primary};
    letter-spacing: -0.5px;
    text-align: center;
  }

  .info {
    margin-top: 10px;

    p {
      font-size: 0.85rem;
      font-style: italic;
      color: #CCCCCC;
      color: ${props => (props.isDragReject ? colors.red : '#CCCCCC')};
      text-align: center;
    }

    .format {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 8px;

      span {
        font-size: 0.7rem;
        color: ${colors.white};
        text-transform: uppercase;
        padding: 2px 4px;
        margin-right: 3px;
        background-color: ${props => (props.isDragReject ? colors.red : '#CCCCCC')};
        border-radius: 5px;

        :last-child {
          margin-left: 3px;
          margin-right: 0;
        }
      }
    }
  }

  @media screen and (max-width: 619px) {
    width: 100%;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .img {
    width: 170px;
    height: 170px;
    background-color: ${colors.white};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    border-radius: 8px;
    border: ${props => (!props.isDragReject ? `2px solid ${colors.white}` : `2px solid ${colors.red}`)};
  }

  .delete {
    display: flex;
    align-items: center;
    background: none;
    border-radius: 5px;
    padding: 3px 6px;
    margin-top: 15px;
    border: none;
    cursor: pointer;
    font-family: 'Open Sans', sans-serif;
    
    span {
      font-size: 0.8rem;
      font-weight: 700;
      color: ${colors.red};
      text-transform: uppercase;
    }

    .fa-times {
      font-size: 0.9rem;
      color: ${colors.red};
      margin-top: 2px; 
      margin-right: 3px; 
    }

    :hover { opacity: 0.9 }
  }

  @media screen and (max-width: 619px) {
    width: 100%;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 30px;
  background-color: #E9E9E9;

  p {
    font-size: 0.9rem;
    padding-left: 30px;
    border-left: 1px solid #CCCCCC;
  }

  @media screen and (max-width: 619px) {
    display: block;
    padding-left: 0;
    border: none;
  }
`;

export const ToggleContainer = styled.label`
  display: flex;
  width: 190px;
  height: 24px;
  margin-right: 30px;

  span {
    padding-top: 2px;
    padding-left: 15px;
    opacity: 1 !important;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 600;
    color: ${colors.primary};
    white-space: nowrap;
  }

  @media screen and (max-width: 619px) {
    margin: 0 30px 15px;
  }
`;
